import requests from "@/utils/axios";
import baseApi from "@/api/baseApi";

export default {
    ...baseApi,
    // 模块URL
    modulesUrl: "/module/device",
    delMonitorData(query: any) {
        return requests.post(this.modulesUrl + "/delMonitorData", query);
    },
};
